import type { SessionStoreSlice } from "./sessionStoreSlice";

export const sessionDefaultValues: SessionStoreSlice = {
    subscriptions: [],
    selectedFulfilment: undefined,
};
